import VehicleChatTopView from './VehicleChatTopView';

export default VehicleChatTopView;
